import { Badge, Button, Col, Dropdown, Input, Modal, Row, Segmented, Select, Switch, Table, Tooltip, Typography, message } from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  AUTH_TOKEN,
  REACT_APP_PAM_API,
  ORG_ID,
  DOMAIN_ID,
  REACT_APP_API_TENANTS_URL,
} from "../../../constants";
import axios from "axios";
import { OnboardLinuxV2 } from "./addEndpoint/OnboardLinuxV2";
import { OnboardWindowV2 } from "./addEndpoint/OnboardWindowV2";
import { OnboardSshTarget } from "./addEndpoint/OnboardSshTarget";
import { MonitorCog, MonitorPlay, Plus, Router, Terminal } from "lucide-react";
import { AN_COLORS, AN_MONO } from "../../../design-system/tokens";
import {
  CountChip,
  FilterCard,
  FilterField,
  MonoCell,
  PageHeader,
  PageShell,
  RowActionMenu,
  iconButtonStyle,
  SquareBadge,
  StatusPill,
  TableCard,
  anTableProps,
  tableEmpty,
} from "../../../design-system/tableUi";
import { logOutUser } from "../../../common";
import { MoreOutlined } from "@ant-design/icons";
import AssignUser from "./AssignUser";
import AuthFlow from "./AuthFlow";
import { useDebounce } from "../../../common/debounce";
import moment from "moment-timezone";
import { InboxOutlined } from "@ant-design/icons";
import { AutoComplete } from "antd";
import {
  endpointLifecycle,
  listJumpServer,
  myTargets,
  recommissionEndpoint,
  scanAccounts,
  scanStatus,
  scanWaitingForSetup,
} from "../../../service/sshProxyService";
import {
  DecommissionDialog,
  passwordsKeptText,
  decommissionJobFailure,
  recommissionConfirm,
  recommissionError,
  SetupScriptBody,
  useDecommissionJobs,
} from "./setupScan";
import { isAdminUser } from "../../../utils/helpers";
import { endpointDetailsPath } from "./endpointLinks";
import { ConnectButton } from "./connect/ConnectDialog";
import { AddManagedAccountModal } from "./EndpointManagedAccountsTab";

// Same test as the detail page, which shows its Gateway Access tab only for
// Linux endpoints: the list carries the OS name, local-mode mocks the id "2".
const isLinuxRow = (r) => {
  const os = String(r.osname || r.osName || "").trim();
  return os === "2" || /linux|ubuntu|debian|centos|rhel|red ?hat|rocky|alma|suse|fedora|amazon/i.test(os);
};

// The OS cell: the reported distribution (osDetail, e.g. "Ubuntu 24.04.1 LTS")
// when there is one, else the OS name. Numeric ids are the OS list's own, as
// on the detail page.
const OS_IDS = { 1: "Windows", 2: "Linux" };
const osText = (r) => {
  const detail = String(r.osDetail || "").trim();
  if (detail) return detail;
  const s = String(r.osname || r.osName || "").trim();
  return OS_IDS[s] || s;
};

const ONE_LINE = { display: "block", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

// Stable empty list for rows without targets, so their Connect cell renders nothing.
const NO_TARGETS = [];

const Endpoints = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [endpointData, setEndpointData] = useState([]);
  const [filterBy, setfilterBy] = useState("");
  // Decommissioned endpoints are history: hidden unless asked for, or unless
  // the State filter picks them out.
  const [showRetired, setShowRetired] = useState(false);
  const [filteredValue, setFilteredValue] = useState("");
  const [isAssignUser, setIsAssignUser] = useState(false);
  // Which OS the add dialog is showing; null closes it.
  const [addOs, setAddOs] = useState(null);

  const [notification, setNotification] = message.useMessage();
  const [modal, modalCtx] = Modal.useModal();
  const isAdmin = isAdminUser();
  const [selectedEndpoints] = useState(null);
  const [isAuthFlow, setIsAuthFlow] = useState(false);
  const [osList, setOsList] = useState([]);
  console.log("osList", osList);

  const [isTabChange, setIsTabChange] = useState(false);
  const [sortModel, setSortModel] = useState();
  const debouncedValue = useDebounce(search, 500);

  //pagination
  const [paginationParams, setPaginationParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGESIZE = 10;
  const [currentPageModel, setCurrentPageModel] = useState({
    pageSize: PAGESIZE,
    page: 0,
  });
  const { Text } = Typography;
  const [options, setOptions] = useState([]);
  // Gateway names by id, so the table can say which proxy reaches each row.
  const [gatewayNames, setGatewayNames] = useState({});
  // Latest account scan per gateway endpoint, shown in the Status tooltip.
  // Gateway endpoints run no agent; the scan and the gateway's probe are what
  // show the machine is reachable.
  const [scans, setScans] = useState({});
  // The signed-in person's own targets, by endpoint id, read once per page:
  // the Connect column shows a button only where they have one. Empty until
  // loaded, so no row's button reads them again by itself.
  const [targetsByEndpoint, setTargetsByEndpoint] = useState({});
  // Decommission: the dialog's row (and whether Force starts ticked), and the
  // clean-up jobs that ended without cleaning the machine, by instanceId.
  const [decomTarget, setDecomTarget] = useState(null);
  // The row whose "Add user…" dialog is open.
  const [addUserRow, setAddUserRow] = useState(null);
  const [decomFailed, setDecomFailed] = useState({});

  const handleSearch = (value) => {
    if (!value) {
      setOptions([]);
      return;
    }
    const filteredOptions = endpointData
      .filter((endpointdata) =>
        endpointdata.hostName.toLowerCase().includes(value.toLowerCase())
      )
      .map((endpointdata) => ({
        label: endpointdata.hostName,
        value: endpointdata.hostName,
      }));

    setOptions(filteredOptions);
  };

  useEffect(() => {
    fetchInstance();
  }, [debouncedValue, filteredValue, paginationParams, currentPage]);

  useEffect(() => {
    listJumpServer({
      payload: { pageSize: 200 },
      onSuccess: (data) =>
        setGatewayNames(
          Object.fromEntries((data?.jumpServers || []).map((g) => [g.id, g.serverName || `Gateway #${g.id}`])),
        ),
      onFailure: () => {},
    });
    myTargets({
      onSuccess: ({ targets }) => {
        const by = {};
        targets.forEach((t) => {
          (by[String(t.endpointId)] = by[String(t.endpointId)] || []).push(t);
        });
        setTargetsByEndpoint(by);
      },
      onFailure: () => {},
    });
  }, []);

  const EndpointStatus = (lastUpdated) => {
    const timezone = localStorage.getItem("timezone");
    const lastActive = moment
      .unix(lastUpdated)
      .tz(timezone)
      .format("YYYY-MM-DD HH:mm:ss");
    const diff = moment().diff(lastActive, "minutes");
    let hours = Math.floor(diff / 60);
    let days = Math.floor(hours / 24);
    let minutes = diff % 60;

    let message;

    if (days > 0) {
      message = `Last Active: ${days} days ago`;
    } else if (hours > 0) {
      message = `Last Active: ${hours} hours${
        minutes > 0 ? ` and ${minutes} minutes ago` : " hours ago"
      }`;
    } else {
      message = `Last Active: ${diff} minutes ago`;
    }

    if (diff > 20) {
      return (
        <Tooltip title={message}>
          <Badge status="error" text="Offline" />
        </Tooltip>
      );
    } else if (diff > 10) {
      return (
        <Tooltip title={message}>
          <Badge status="warning" text="Offline" />
        </Tooltip>
      );
    }
    return <Badge status="success" text="Online" />;
  };

  const handleStatus = async (record) => {
    console.log(record);
    let status = record.status.toLowerCase();
    let data = {
      domainId: DOMAIN_ID(),
      status:
        status === "active" ? "Inactive" : status === "inactive" && "Active",
      instanceIds: [record.instanceId],
      token: AUTH_TOKEN(),
      orgId: ORG_ID(),
    };
    let url = `${REACT_APP_PAM_API}/instances/updateInstanceStatus`;
    try {
      await axios.put(url, data, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });
      await fetchInstance();
      notification.open({
        type: "success",
        content: `${record.hostName} is ${
          record.status === "Active" ? "deactivated" : "activated"
        } successfull`,
      });
    } catch (err) {
      if (
        err.response.data.message === "Invalid credentials" ||
        err?.response?.status === 401
      ) {
        notification.open({
          type: "error",
          content: "Credentials are invalid",
        });
        logOutUser();
      } else if (err.response.status === 401) {
        logOutUser();
      } else {
        notification.open({
          type: "error",
          content: "Unable to update status",
        });
      }
    }
  };

  const columns = [
    {
      headerName: "Host Name",
      field: "hostName",
      key: "hostName",
      flex: 1,
      // width: 100,
      renderCell: (val) => (
        <Link
          disabled={val.row.hostName === 0 ? true : false}
          // state={{
          //   hostAddress: val.row.hostName,
          //   instanceId: val.row.instanceId,
          // }}
          to={endpointDetailsPath(val.row.instanceId)}
          onClick={() => {
            localStorage.removeItem("details");
            localStorage.setItem("endPoints", JSON.stringify(val.row));
            let values = {
              hostAddress: val.row.hostName,
              instanceId: val.row.instanceId,
            };
            localStorage.setItem("details", JSON.stringify(values));
          }}
        >
          {val.row.hostName}
        </Link>
      ),
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1,
      key: "description",
       renderCell: (params) => {
        const desc = params.row.description || "-";
        const showTooltip = desc.length > 20;
 
        return showTooltip ? (
          <div className="relative w-full">
            <Tooltip title={desc} placement="rightBottom" arrow>
              <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">
                {desc}
              </div>
            </Tooltip>
          </div>
        ) : (
          <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">{desc}</div>
        );
      },
    },
    { headerName: "OS", flex: 1, field: "osname", key: "osname" },
    // {
    //   headerName: "User Count",
    //   field: "countOfUsers",
    //   key: "countOfUsers",
    //   width: 150,
    //   renderCell: (val) => {
    //     const isDisabled = val?.row?.countOfUsers === 0;
    //     return (
    //       <>
    //         {isDisabled ? (
    //           <span style={{ cursor: "not-allowed" }}>{val?.row?.countOfUsers}</span>
    //         ) : (
    //           <Link
    //             to={`/pam/endpoint/endpointDetails?defaultTab=usercount`}
    //             state={{
    //               hostAddress: val.row.hostName,
    //               instanceId: val.row.instanceId,
    //             }}
    //             onClick={() => {
    //               localStorage.removeItem("details");
    //               let values = {
    //                 hostAddress: val.row.hostName,
    //                 instanceId: val.row.instanceId,
    //               };
    //               localStorage.setItem("details", JSON.stringify(values));
    //             }}
    //           >
    //             {val?.row?.countOfUsers}
    //           </Link>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      headerName: "Public IP",
      field: "publicIp",
      flex: 1,
      key: "publicIp",
      renderCell: (params) => params.row.publicIp || "-",
    },
    {
      headerName: "Private IP",
      field: "privateIp",
      flex: 1,
      key: "privateIp",
      renderCell: (params) => params.row.privateIp || "-",
    },
    {
      headerName: "FQDN",
      field: "fqdn",
      flex: 1,
      key: "fqdn",
      renderCell: (params) => params.row.fqdn || "-",
    },

    // {
    //   headerName: "Group Count",
    //   field: "countOfGroups",
    //   key: "countOfGroups",
    //   width: 150,
    //   renderCell: (val) => {
    //     const isDisabled = val?.row?.countOfGroups === 0;
    //     return (
    //       <>
    //         {isDisabled ? (
    //           <span style={{ cursor: "not-allowed" }}>{val?.row?.countOfGroups}</span>
    //         ) : (
    //           <Link
    //             state={{
    //               hostAddress: val.row.hostName,
    //               instanceId: val.row.instanceId,
    //             }}
    //             onClick={() => {
    //               localStorage.removeItem("details");
    //               let values = {
    //                 hostAddress: val.row.hostName,
    //                 instanceId: val.row.instanceId,
    //               };
    //               localStorage.setItem("details", JSON.stringify(values));
    //             }}
    //             to={`/pam/endpoint/endpointDetails?tab=${isTabChange}&defaultTab=groupcount`}
    //           >
    //             {val?.row?.countOfGroups}
    //           </Link>
    //         )}
    //       </>
    //     );
    //   },
    // },

    {
      headerName: "Status",
      field: "status",
      key: "status",
      flex: 1,
      // width: 120,
      renderCell: (val) => {
        let stateVal =
          val.row.status.toLowerCase() === "active" ? "Active" : "Inactive";
        return (
          <>
            <Text type={stateVal === "Active" ? "success" : "danger"}>
              {" "}
              {stateVal}
            </Text>
          </>
        );
      },
    },
    {
      headerName: "Agent Status",
      field: "AgentStatus",
      flex: 1,
      key: "status",
      renderCell: (val) => EndpointStatus(val.row.lastActive),
    },
    {
      headerName: "Action",
      field: "action",
      key: "action",
      // flex: 1,
      renderCell: (val) => (
        <Dropdown
          placement="bottomLeft"
          menu={{
            items: [
              // {
              //   key: "assign",
              //   label: (
              //     <Link
              //       onClick={() => {
              //         setSelectedEndpoints(val.row);
              //         setIsAssignUser(true);
              //       }}
              //     >
              //       Assign Users
              //     </Link>
              //   ),
              // },
              // {
              //   key: "User",
              //   label: <Link>User</Link>,
              // },
              {
                key: "Agent Logs",
                label: (
                  <Link
                    to={`/pam/endpoint/agentLogs?hostName=${val.row.hostName}`}
                  >
                    Agent Logs
                  </Link>
                ),
              },

              // {
              //   key: "authFlow",
              //   label: (
              //     <Link
              //       onClick={() => {
              //         setIsAuthFlow(true);
              //         setSelectedEndpoints(val.row);
              //       }}
              //     >
              //       Auth Flow
              //     </Link>
              //   ),
              // },

              {
                key: "Password Policies",
                label: (
                  <Link
                    to={`/pam/endpoint/passwordPolicies?hostaddress=${val.row.hostName}`}
                  >
                    Password Policies
                  </Link>
                ),
              },
              {
                key: "state",
                label: (
                  <Link onClick={() => handleStatus(val.row)}>
                    {val.row.status.toLowerCase() === "active"
                      ? "Deactivate"
                      : "Activate"}
                  </Link>
                ),
                danger:
                  val.row.status.toLowerCase() === "active" ? true : false,
              },
            ],
          }}
        >
          <Button type="text" shape="circle" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  const calculateColumnWidths = (
    data,
    columnsToAutoSize,
    includeHeaders = false
  ) => {
    const columnWidths = {};

    columnsToAutoSize.forEach((col) => {
      let maxWidth = includeHeaders ? col.length * 13 : 0;

      data.forEach((row) => {
        const value = row[col];
        const width = value ? value.toString().length * 13 : 0;
        if (width > maxWidth) {
          maxWidth = width;
        }
      });

      columnWidths[col] = maxWidth;
    });

    return columnWidths;
  };

  // Calculate column widths
  const columnWidths = calculateColumnWidths(
    endpointData,
    [
      "hostName",
      "status",
      "totalUsers",
      "privateIp",
      "publicIp",
      "totalGroups",
      "action",
      "AgentStatus",
    ],
    true
  );

  // Apply the calculated widths to the columns
  const adjustedColumns = columns.map((col) => ({
    ...col,
    width: columnWidths[col.field] || col.width,
  }));

  const handleSortModelChange = (model) => {
    setSortModel(model);
  };

  const fetchInstance = () => {
    let pageDetails = {
      domainId: DOMAIN_ID(),
      pageId: currentPage + 1,
      pageSize: currentPageModel.pageSize,
      search: debouncedValue,
      filter: {
        filterBy: filterBy,
        value: filteredValue,
      },
      token: AUTH_TOKEN(),
      orgId: ORG_ID(),
      MachineType: "endpoint",
    };
    setIsLoading(true);
    axios
      .post(`${REACT_APP_PAM_API}/instances/list`, pageDetails, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        setIsLoading(false);
        const originalEpm = res?.data?.instances;
        localStorage.setItem("instances", JSON.stringify(originalEpm));
        const epmWithId = originalEpm.map((epm, index) => ({
          ...epm,
          id: index + 1,
          countOfUsers: 0,
          countOfGroups: 0,
          osname: epm.osName,
        }));
        setEndpointData(epmWithId ?? []);
        // One scan-status read per gateway endpoint on this page.
        (epmWithId || [])
          .filter((r) => r.jumpServerId && r.instanceId && !endpointLifecycle(r.status))
          .forEach((r) =>
            scanStatus({
              instanceId: r.instanceId,
              onSuccess: (st) => setScans((m) => ({ ...m, [r.instanceId]: st })),
              onFailure: () => {},
            }),
          );
        setTotalCount(res?.data?.totalCount);
        setCurrentPageModel({
          pageSize: 10,
          page: currentPage,
        });

        const fetchInstanceOsType = () => {
          let pageDetails = {
            tenantId: DOMAIN_ID(),
            orgId: ORG_ID(),
          };
          axios
            .post(`${REACT_APP_API_TENANTS_URL}/getOsList`, pageDetails, {
              headers: {
                withCredentials: true,
                "X-Authorization": AUTH_TOKEN(),
              },
            })
            .then(({ data }) => {
              localStorage.setItem("osList", JSON.stringify(data?.osList));
              const osData = data?.osList.map((os) => ({
                value: os.id.toString(),
                label:
                  os.osName.toLowerCase() === "windows"
                    ? "Windows"
                    : os.osName.toLowerCase() === "linux"
                    ? "Linux"
                    : os.osName,
              }));
              setOsList(osData ?? []);

              const dataWithOs = epmWithId.map((epm) => {
                const osItem = osData.find((os) => os.value === epm.osName);
                return {
                  ...epm,
                  osname: osItem ? osItem.label : epm.osName,
                };
              });
              setEndpointData(dataWithOs);
              const ids = originalEpm.map((item) => item.instanceId);

              const childApiCalls = ids.map((id) => {
                return Promise.all([fetchUserCount(id), fetchGroupCount(id)]);
              });

              // Wait for all child API calls to resolve
              Promise.all(childApiCalls)
                .then((results) => {

                  // Update the epmWithId with the results from both user and group count
                  let updatedEpm = dataWithOs.map((epm, index) => {
                    const userCountData = results[index][0]?.data; // First item of Promise.all() result
                    const groupCountData = results[index][1]?.data; // Second item of Promise.all() result

                    return {
                      ...epm,
                      countOfUsers: userCountData?.count || 0,
                      countOfGroups: groupCountData?.count || 0,
                    };
                  });

                  setEndpointData(updatedEpm);
                })
                .catch((error) => {
                  console.error("Error in child API calls", error?.response?.status, error?.message);
                });
            })
            .catch((err) => {
              if (
                err.response.data.message === "Invalid credentials" ||
                err?.response?.status === 401
              ) {
                notification.open({
                  type: "error",
                  content: "Credentials are invalid",
                });
                logOutUser();
              } else if (err.response.status === 401) {
                logOutUser();
              } else {
                notification.open({
                  type: "error",
                  content: "Unable to fetch OS",
                });
              }
            });
        };
        fetchInstanceOsType();
      })
      .catch((err) => {
        setIsLoading(false);
        if (
          err?.response?.data?.message === "Invalid credentials" ||
          err?.response?.status === 401
        ) {
          notification.open({
            type: "error",
            content: "Credentials are invalid",
          });
          logOutUser();
        } else {
          notification.open({
            type: "error",
            content: "Unable to fetch endpoints",
          });
        }
      });
  };

  const fetchUserCount = (id) => {
    let userCountRequest = {
      tenantId: DOMAIN_ID(),
      machineId: id,
      orgId: ORG_ID(),
      uuid: "",
    };

    return axios
      .post(
        `${REACT_APP_API_TENANTS_URL}/getCountofEpmUserByEndpoint`,
        userCountRequest,
        {
          headers: {
            "X-Authorization": AUTH_TOKEN(),
            withCredentials: true,
          },
        }
      )
      .then((childData) => {
        return childData; // Return the child data to be used in Promise.all
      })
      .catch((error) => {
        console.error("Error in child API call for ID", id, ":", error?.response?.status, error?.message);
      });
  };
  const fetchGroupCount = (id) => {
    let userCountRequest = {
      tenantId: DOMAIN_ID(),
      machineId: id,
      orgId: ORG_ID(),
      uuid: "",
    };

    return axios
      .post(
        `${REACT_APP_API_TENANTS_URL}/getCountofEpmUserGroupByEndpoint`,
        userCountRequest,
        {
          headers: {
            "X-Authorization": AUTH_TOKEN(),
            withCredentials: true,
          },
        }
      )
      .then((childData) => {
        return childData;
      })
      .catch((error) => {
        console.error("Error in child API call for ID", id, ":", error?.response?.status, error?.message);
      });
  };


  const filter = (inputValue, path) =>
    path.some(
      (option) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );

  const handleFilter = (_, data) => {
    console.log(data);
    setfilterBy(data ? data[0]?.value : "");
    setFilteredValue(data ? data[1]?.value : "");
    // setPaginationParams({ current: 1, pageSize: 10 });
    setCurrentPage(0);
  };


  // The OS choice lives inside the dialog as a toggle rather than in a popover
  // before it: it is one decision among several the flow asks for, and putting
  // it behind a menu made the dialog feel like the second step of two.
  const OS_CHOICES = [
    // Agentless: nothing installed, reached through an SSH gateway.
    { value: "ssh", label: "Linux server (via SSH gateway)", Icon: Router },
    { value: "linux", label: "Linux", Icon: Terminal },
    { value: "windows", label: "Windows", Icon: MonitorCog },
  ];

  const FILTER_FIELDS = [
    { value: "State", label: "State" },
    { value: "osname", label: "OS" },
  ];
  const filterValueOptions =
    filterBy === "State"
      ? [
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
          { value: "decommissioning", label: "Decommissioning" },
          { value: "decommissioned", label: "Decommissioned" },
        ]
      : filterBy === "osname"
      ? osList
      : [];

  // The detail page reads the whole row from `endPoints` (IPs, FQDN, status,
  // jumpServerId) and the narrower `details` for its child tabs. Both are
  // needed — writing only `details` leaves the summary card showing whatever
  // the previous visit left behind.
  const storeEndpoint = (r) => {
    localStorage.setItem("endPoints", JSON.stringify(r));
    localStorage.removeItem("details");
    localStorage.setItem("details", JSON.stringify({ hostAddress: r.hostName, instanceId: r.instanceId }));
  };

  // Administrator only; the backend refuses others too.
  const queueScan = (r) =>
    scanAccounts({
      instanceId: r.instanceId,
      onSuccess: () => notification.success("Scan queued"),
      onFailure: (err) => {
        const status = err?.response?.status;
        notification.error(
          status === 409
            ? "Assign a gateway to this endpoint first"
            : status === 403
            ? "Administrator role required"
            : err?.response?.data?.error || "Couldn't queue the scan"
        );
      },
    });

  // Rows being decommissioned have their clean-up followed here, so the row
  // moves on by itself: done → Decommissioned; failed → offer force.
  const setRowStatus = (instanceId, status) =>
    setEndpointData((rows) => rows.map((r) => (String(r.instanceId) === String(instanceId) ? { ...r, status } : r)));
  const hostOf = (instanceId) =>
    endpointData.find((r) => String(r.instanceId) === String(instanceId))?.hostName || "The endpoint";
  useDecommissionJobs(
    endpointData
      .filter((r) => endpointLifecycle(r.status) === "decommissioning" && !decomFailed[r.instanceId])
      .map((r) => r.instanceId),
    (id, job) => {
      if (job.status === "done") {
        setRowStatus(id, "Decommissioned");
        notification.success(`${hostOf(id)} decommissioned — the gateway cleaned up the machine`);
        fetchInstance();
      } else {
        setDecomFailed((m) => ({ ...m, [id]: job }));
        notification.error(`${hostOf(id)}: ${decommissionJobFailure(job)} Retry, or finish with force.`);
      }
    },
  );

  const onDecommissioned = (res) => {
    if (!decomTarget) return;
    const { instanceId, hostName } = decomTarget.row;
    setDecomFailed((m) => {
      const next = { ...m };
      delete next[instanceId];
      return next;
    });
    if (res.status === "decommissioning") {
      setRowStatus(instanceId, "Decommissioning");
      notification.info(
        [`${hostName || "The endpoint"} is decommissioning. The gateway is cleaning up the machine.`, passwordsKeptText(res)].filter(Boolean).join(" "),
      );
    } else if (res.status === "decommissioned") {
      setRowStatus(instanceId, "Decommissioned");
      if (res.machineCleaned !== false)
        notification.info([`${hostName || "The endpoint"} is decommissioned`, passwordsKeptText(res)].filter(Boolean).join(". "));
    }
    fetchInstance();
  };

  // Recommissioning issues a new setup key, so it is confirmed; the new script
  // is shown in a dialog here.
  const confirmRecommission = (r) =>
    modal.confirm({
      ...recommissionConfirm(r.hostName),
      onOk: () =>
        recommissionEndpoint({
          instanceId: r.instanceId,
          onSuccess: (result) => {
            setRowStatus(r.instanceId, result.status || "Active");
            fetchInstance();
            modal.success({
              title: `${r.hostName || "The endpoint"} is active again`,
              width: 720,
              okText: "Done",
              content: <SetupScriptBody result={result} />,
            });
          },
          onFailure: (err) => {
            const e = recommissionError(err);
            notification.error(e.text);
            if (e.active) fetchInstance();
          },
        }),
    });

  const anColumns = [
    {
      // The FQDN rides under the name (when it says more than the name), and
      // both addresses share one column, so the list fits without scrolling.
      title: "Host name",
      key: "hostName",
      render: (_, r) => (
        <span style={{ display: "grid", minWidth: 0 }}>
          <Link
            to={endpointDetailsPath(r.instanceId)}
            onClick={() => storeEndpoint(r)}
            style={{ ...ONE_LINE, fontWeight: 500, color: AN_COLORS.ink }}
            title={r.hostName || undefined}
          >
            {r.hostName || "—"}
          </Link>
          {r.fqdn && r.fqdn !== r.hostName && (
            <span style={{ ...ONE_LINE, fontFamily: AN_MONO, fontSize: 11.5, color: AN_COLORS.muted }} title={r.fqdn}>
              {r.fqdn}
            </span>
          )}
        </span>
      ),
    },
    {
      title: "Address",
      key: "address",
      width: "9.375rem",
      render: (_, r) =>
        r.privateIp || r.publicIp ? (
          <span style={{ display: "grid" }}>
            <MonoCell title={r.privateIp ? "Private IP" : "Public IP"}>{r.privateIp || r.publicIp}</MonoCell>
            {r.privateIp && r.publicIp && r.publicIp !== r.privateIp && (
              <span style={{ fontFamily: AN_MONO, fontSize: 11.5, color: AN_COLORS.muted }} title="Public IP">
                {r.publicIp} public
              </span>
            )}
          </span>
        ) : (
          <MonoCell />
        ),
    },
    {
      // Fixed width; a long distribution name ellipsises, full text on hover.
      title: "OS",
      key: "osname",
      width: "6.875rem",
      render: (_, r) => {
        const os = osText(r);
        return (
          <SquareBadge truncate title={os || undefined}>
            {os}
          </SquareBadge>
        );
      },
    },
    {
      // jumpServerId is omitted by the API when unassigned. Assigned from the
      // endpoint's detail page.
      title: "Gateway",
      key: "jumpServerId",
      width: "8.125rem",
      render: (_, r) =>
        r.jumpServerId ? (
          <span style={{ fontSize: 12 }}>{gatewayNames[r.jumpServerId] || `Gateway #${r.jumpServerId}`}</span>
        ) : (
          <span style={{ color: AN_COLORS.muted }}>—</span>
        ),
    },
    {
      // Administrative status; for a gateway endpoint, with whether its gateway
      // reaches it (it runs no agent, so there is no heartbeat to show).
      title: "Status",
      key: "status",
      width: "12.25rem",
      render: (_, r) => {
        const lifecycle = endpointLifecycle(r.status);
        if (lifecycle === "decommissioned") return <StatusPill status="decommissioned" label="Decommissioned" tone="neutral" />;
        if (lifecycle === "decommissioning" && decomFailed[r.instanceId]) {
          return (
            <Tooltip title={decommissionJobFailure(decomFailed[r.instanceId])}>
              <span>
                <StatusPill status="decommissioning" label="Clean-up failed" tone="danger" />
              </span>
            </Tooltip>
          );
        }
        if (lifecycle === "decommissioning") return <StatusPill status="decommissioning" label="Decommissioning" tone="warn" />;
        if (!r.jumpServerId) return <StatusPill status={r.status || "unknown"} />;
        return (
          <GatewayStatus
            status={r.status}
            gateway={gatewayNames[r.jumpServerId] || `Gateway #${r.jumpServerId}`}
            scan={scans[r.instanceId]}
            lastActive={r.lastActive}
          />
        );
      },
    },
    {
      // Only where a policy gives the signed-in person an account here.
      // Wide enough for the button: with a fixed layout a narrower cell clips it.
      title: "Connect",
      key: "connect",
      width: "7.75rem",
      render: (_, r) => (
        <ConnectButton instanceId={r.instanceId} hostname={r.hostName} targets={targetsByEndpoint[String(r.instanceId)] || NO_TARGETS} />
      ),
    },
    {
      // Recordings are reached from the endpoint they belong to rather than from
      // a standalone screen — the link carries the host through as a filter.
      title: "Recordings",
      key: "recordings",
      width: "6.5rem",
      align: "center",
      render: (_, r) =>
        r.hostName ? (
          <Tooltip title={`View sessions recorded on ${r.hostName}`}>
            <Link
              // host= is the address the gateway dials, which is what a proxy
              // recording stores as its target host; endpoint= is only the
              // label for the page heading.
              to={`/pam/jumpServer-sessionRecordings?endpoint=${encodeURIComponent(r.hostName)}${
                r.privateIp || r.publicIp ? `&host=${encodeURIComponent(r.privateIp || r.publicIp)}` : ""
              }`}
              aria-label={`View sessions recorded on ${r.hostName}`}
              style={{ ...iconButtonStyle(), color: AN_COLORS.primary }}
            >
              <MonitorPlay size={16} />
            </Link>
          </Tooltip>
        ) : (
          <span style={{ color: AN_COLORS.muted }}>—</span>
        ),
    },
    {
      title: "",
      key: "action",
      width: "3.5rem",
      align: "center",
      render: (_, r) => {
        // A gateway-managed endpoint runs no agent, so agent logs don't apply.
        const items = [
          ...(r.jumpServerId
            ? []
            : [
                { key: "agent-logs", label: <Link to={`/pam/endpoint/agentLogs?hostName=${r.hostName}`}>Agent logs</Link> },
              ]),
          // Add user: live gateway-managed Linux endpoints, as on the detail page.
          ...(isAdmin && isLinuxRow(r) && r.jumpServerId && !endpointLifecycle(r.status)
            ? [{ key: "add-user", label: "Add user…", onClick: () => setAddUserRow(r) }]
            : []),
          ...(isAdmin && isLinuxRow(r) && !endpointLifecycle(r.status)
            ? [
                { key: "scan-accounts", label: "Scan accounts", onClick: () => queueScan(r) },
              ]
            : []),
          // Decommission: live gateway-managed Linux endpoints. A decommissioning
          // one gets nothing — unless its clean-up failed, when force is offered.
          ...(isAdmin && isLinuxRow(r) && r.jumpServerId && !endpointLifecycle(r.status)
            ? [
                { type: "divider" },
                { key: "decommission", label: "Decommission…", danger: true, onClick: () => setDecomTarget({ row: r, force: false }) },
              ]
            : []),
          ...(isAdmin && endpointLifecycle(r.status) === "decommissioning" && decomFailed[r.instanceId]
            ? [
                { key: "decommission-force", label: "Finish with force…", danger: true, onClick: () => setDecomTarget({ row: r, force: true }) },
                { key: "decommission-retry", label: "Try the clean-up again", onClick: () => setDecomTarget({ row: r, force: false }) },
              ]
            : []),
          ...(isAdmin && endpointLifecycle(r.status) === "decommissioned"
            ? [{ key: "recommission", label: "Recommission", onClick: () => confirmRecommission(r) }]
            : []),
        ];
        return items.length ? <RowActionMenu items={items} /> : <span style={{ color: AN_COLORS.muted }}>—</span>;
      },
    },
  ];

  const retiredFilter = filterBy === "State" && !!endpointLifecycle(filteredValue);
  // Only decommissioned rows are hidden: one still decommissioning stays in
  // view, so its clean-up can be followed until it's done.
  const visibleData =
    showRetired || retiredFilter ? endpointData : endpointData.filter((r) => endpointLifecycle(r.status) !== "decommissioned");
  const hiddenRetired = endpointData.length - visibleData.length;

  const applied = [
    filterBy && filteredValue && {
      key: "field",
      label: `${FILTER_FIELDS.find((f) => f.value === filterBy)?.label || filterBy}: ${
        filterValueOptions.find((o) => o.value === filteredValue)?.label || filteredValue
      }`,
      clear: () => {
        setfilterBy("");
        setFilteredValue("");
        setCurrentPage(0);
      },
    },
    search && { key: "search", label: `Host: ${search}`, clear: () => setSearch("") },
    showRetired && { key: "retired", label: "Showing decommissioned", clear: () => setShowRetired(false) },
  ].filter(Boolean);

  return (
    <PageShell>
      {setNotification}
      {modalCtx}

      {/* The endpoint page's Add user dialog; it reads the add-user limits itself. */}
      <AddManagedAccountModal
        open={!!addUserRow}
        instanceId={addUserRow?.instanceId}
        hostname={addUserRow?.hostName}
        onClose={() => setAddUserRow(null)}
        onCreated={(_, account) =>
          notification.success(`${account} is being added — it shows as active within about a minute.`)
        }
      />

      <PageHeader
        eyebrow="PAM · Targets"
        title="Endpoints"
        subtitle="Machines under management. A machine is reached through its gateway, with a key issued per approved session."
        chips={<CountChip count={totalCount} label={totalCount === 1 ? "Endpoint" : "Endpoints"} />}
        actions={
          <Button type="primary" icon={<Plus size={13} strokeWidth={2.2} />} onClick={() => setAddOs("ssh")}>
            Add endpoint
          </Button>
        }
      />

      <FilterCard
        columns="1.6fr 1fr 1fr auto"
        applied={applied}
        onClearAll={() => {
          setfilterBy("");
          setFilteredValue("");
          setSearch("");
          setShowRetired(false);
          setCurrentPage(0);
        }}
        showing={visibleData.length}
        total={totalCount}
      >
        <FilterField label="Search host name">
          <AutoComplete
            placeholder="web-01.prod"
            allowClear
            onSearch={handleSearch}
            options={options}
            onChange={setSearch}
            style={{ width: "100%", height: 36 }}
          />
        </FilterField>

        {/* Two plain Selects rather than a Cascader: the same field-then-value
            shape every other table on PAM uses, and it fits the 36px filter row
            instead of opening an oversized flyout. */}
        <FilterField label="Filter by">
          <Select
            allowClear
            placeholder="Any"
            value={filterBy || undefined}
            onChange={(v) => {
              setfilterBy(v || "");
              setFilteredValue("");
              setCurrentPage(0);
            }}
            options={FILTER_FIELDS}
            style={{ width: "100%", height: 36 }}
          />
        </FilterField>

        <FilterField label="Value">
          <Select
            showSearch
            allowClear
            optionFilterProp="label"
            placeholder={filterBy ? "Select a value" : "Pick a field first"}
            disabled={!filterBy}
            value={filteredValue || undefined}
            onChange={(v) => {
              setFilteredValue(v || "");
              setCurrentPage(0);
            }}
            options={filterValueOptions}
            style={{ width: "100%", height: 36 }}
          />
        </FilterField>

        <FilterField label="Decommissioned">
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8, height: 36, fontSize: 13, color: AN_COLORS.ink2, whiteSpace: "nowrap", cursor: "pointer" }}>
            <Switch size="small" checked={showRetired || retiredFilter} disabled={retiredFilter} onChange={setShowRetired} />
            Show decommissioned
            {!showRetired && !retiredFilter && hiddenRetired > 0 && (
              <span style={{ color: AN_COLORS.muted }}>({hiddenRetired} hidden)</span>
            )}
          </label>
        </FilterField>
      </FilterCard>

      <TableCard>
        <Table
          {...anTableProps}
          columns={anColumns}
          dataSource={visibleData}
          rowKey={(r) => r.instanceId}
          rowClassName={(r) => (endpointLifecycle(r.status) ? "an-row-retired" : "")}
          loading={isLoading}
          tableLayout="fixed"
          scroll={{ x: "56rem" }}
          locale={tableEmpty(isLoading, applied.length ? "No endpoints match your filters." : "No endpoints yet.")}
          pagination={{
            current: currentPage + 1,
            pageSize: 10,
            total: totalCount,
            showSizeChanger: false,
            onChange: (pg) => setCurrentPage(pg - 1),
          }}
        />
      </TableCard>


      {/* Onboarding opens as a form dialog, the same shape as Add User on the
          AD screens: centred, titled, footer={null} because the flow carries
          its own Finish. The routes still exist for deep links. */}
      <Modal
        open={!!addOs}
        onCancel={() => setAddOs(null)}
        footer={null}
        width={900}
        destroyOnClose
        // The OS toggle lives in the title, which antd renders in the fixed
        // header — so it stays put while the steps below it scroll.
        title={
          <div>
            <div style={{ marginBottom: 10 }}>Add Endpoint</div>
            {/* antd's default selected state is white-on-grey, which reads as
                "neither is chosen" at a glance. Use the brand tint the rest of
                the console uses for a selected control. */}
            <style>{`
              .an-os-segmented .ant-segmented-item {
                color: ${AN_COLORS.muted};
                font-weight: 500;
                transition: color 120ms;
              }
              .an-os-segmented .ant-segmented-item-label {
                padding: 0 16px;
                line-height: 32px;
                min-height: 32px;
              }
              .an-os-segmented .ant-segmented-item:hover:not(.ant-segmented-item-selected) {
                color: ${AN_COLORS.ink2};
              }
              .an-os-segmented .ant-segmented-item-selected {
                background: ${AN_COLORS.primaryL} !important;
                color: ${AN_COLORS.primaryD} !important;
                box-shadow: inset 0 0 0 1px ${AN_COLORS.primary};
                font-weight: 600;
              }
              .an-os-segmented .ant-segmented-thumb {
                background: ${AN_COLORS.primaryL} !important;
                box-shadow: inset 0 0 0 1px ${AN_COLORS.primary};
              }
            `}</style>
            <Segmented
              className="an-os-segmented"
              value={addOs || "ssh"}
              onChange={setAddOs}
              options={OS_CHOICES.map(({ value, label, Icon }) => ({
                value,
                label: (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 7, fontSize: 13.5 }}>
                    <Icon size={14} />
                    {label}
                  </span>
                ),
              }))}
            />
          </div>
        }
        styles={{ body: { maxHeight: "68vh", overflowY: "auto", paddingTop: 4 } }}
      >
        {addOs === "linux" && <OnboardLinuxV2 embedded onDone={() => { setAddOs(null); fetchInstance(); }} />}
        {addOs === "windows" && <OnboardWindowV2 embedded onDone={() => { setAddOs(null); fetchInstance(); }} />}
        {addOs === "ssh" && <OnboardSshTarget embedded onDone={() => { setAddOs(null); fetchInstance(); }} />}
      </Modal>

      <DecommissionDialog
        open={!!decomTarget}
        instanceId={decomTarget?.row.instanceId}
        hostName={decomTarget?.row.hostName}
        hasGateway={!!decomTarget?.row.jumpServerId}
        defaultForce={!!decomTarget?.force}
        onClose={() => setDecomTarget(null)}
        onDone={onDecommissioned}
      />

      {isAssignUser && (
        <AssignUser
          isAssignUser={isAssignUser}
          setIsAssignUser={setIsAssignUser}
          selectedEndpoints={selectedEndpoints}
        />
      )}
      {isAuthFlow && (
        <AuthFlow
          isAuthFlow={isAuthFlow}
          setIsAuthFlow={setIsAuthFlow}
          selectedEndpoints={selectedEndpoints}
        />
      )}
    </PageShell>
  );
};

// A gateway-managed endpoint runs no agent; its last-active time comes from
// the gateway's probe of its SSH port. Online within 20 minutes, like agents.
const ONLINE_WITHIN_MIN = 20;

// Whether the gateway reaches the machine: Online, Offline · <age>, or not
// reached yet (no lastActive).
const gatewayReach = (lastActive) => {
  const seen = Number(lastActive) > 0 ? moment.unix(Number(lastActive)) : null;
  const online = !!seen && moment().diff(seen, "minutes") <= ONLINE_WITHIN_MIN;
  return {
    seen,
    online,
    label: !seen ? "Not reached yet" : online ? "Online" : `Offline · ${seen.fromNow()}`,
    tone: !seen ? "neutral" : online ? "success" : "danger",
  };
};

// Status for a gateway endpoint: "Active · Online" / "Active · Offline · <age>".
// The tooltip says which gateway reaches it and how its latest account scan went.
function GatewayStatus({ status, gateway, scan, lastActive }) {
  const time = (iso) => (iso ? moment(iso).format("HH:mm") : "");
  let detail = "";
  if (!scan) detail = "";
  else if (scan.status === "done") detail = `last scan ${time(scan.completedAt)}`;
  else if (scanWaitingForSetup(scan)) detail = "waiting for setup";
  else if (scan.status === "queued" || scan.status === "claimed") detail = "scanning…";
  else if (scan.status === "failed" || scan.status === "expired") detail = "last scan failed";
  else if (scan.status === "never") detail = "not scanned yet";

  const reach = gatewayReach(lastActive);
  const key = String(status || "").trim().toLowerCase();
  const name = key ? key.charAt(0).toUpperCase() + key.slice(1) : "Unknown";
  const title = [
    `Reached via ${gateway}`,
    reach.seen ? `last answered ${reach.seen.format("YYYY-MM-DD HH:mm")}` : "the gateway hasn't reached it yet",
    detail,
    scan?.error,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Tooltip title={title}>
      <span>
        {key === "active" ? (
          <StatusPill status={status} label={`${name} · ${reach.label}`} tone={reach.tone} />
        ) : (
          <StatusPill status={status || "unknown"} label={`${name} · ${reach.label}`} />
        )}
      </span>
    </Tooltip>
  );
}

export default Endpoints;
